import http from '@core/fetch'
import { API_SETMEAL_LIST, API_HALL_LIST } from '@constant'

export default {
  // 获取直播统计
  getConsoleStatistical: params =>
    http.get('/p/wedding/index.php/admin/APILiveChannel/consoleStatistical', {
      body: params
    }),
  // 截取视频
  postVideoSeek: params =>
    http.post('/p/wedding/index.php/admin/APILiveChannel/videoSeek', {
      body: params
    }),
  // 获取直播详情
  getVideoDetail: params =>
    http.get('/p/wedding/index.php/admin/APILiveChannel/consoleLiveChannel', {
      body: params
    }),
  // 删除套餐|案例
  deleteRecommend: params =>
    http.post(
      '/p/wedding/index.php/admin/APILiveChannel/delLiveChannelRecommend',
      {
        body: params
      }
    ),
  // 设置套餐为介绍中
  setLiveChannelRecommendIntroduce: params =>
    http.post(
      '/p/wedding/index.php/admin/APILiveChannel/setLiveChannelRecommendIntroduce',
      {
        body: params
      }
    ),
  // 设置套餐的意向金
  setLiveChannelIntent: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/intent', {
      body: params
    }),
  // 修改直播分享配图
  editLiveChannelShareImage: params =>
    http.post(
      '/p/wedding/index.php/admin/APILiveChannel/editLiveChannelShareImage',
      {
        body: params,
        ignore: [null, undefined]
      }
    ),
  // 获取优惠券
  liveChannelCouponContent: params =>
    http.get(
      '/p/wedding/index.php/admin/APILiveChannel/liveChannelCouponContent',
      {
        body: params
      }
    ),
  // 获取红包
  liveChannelCashPackageContent: params =>
    http.get('/p/wedding/index.php/Home/APILiveChannel/redpackets', {
      body: params
    }),
  // 获取所有宴会厅
  getHallList: params =>
    http(API_HALL_LIST, {
      body: params
    }),
  // 获取套餐|案例列表
  getResourcesList: params =>
    http(API_SETMEAL_LIST, {
      body: params
    }),
  // 增加套餐|案例
  addResourcesList: params =>
    http.post(
      '/p/wedding/index.php/admin/APILiveChannel/addLiveChannelRecommend',
      {
        body: params
      }
    ),
  // 聊天记录
  chatHistory: params =>
    http.get(`/live/history`, {
      body: params
    }),
  // 发送聊天信息
  chatAddMsg: params =>
    http.post(`/live/add_msg`, {
      body: params,
      bodyType: 'form'
    }),
  // 删除聊天信息
  chatDelMsg: params =>
    http.post(`/live/del_msg`, {
      body: params,
      bodyType: 'form'
    }),
  // 禁言
  forbiddenWords: params =>
    http.post(' /p/wedding/index.php/admin/APILiveChannel/forbiddenWords', {
      body: params
    }),
  // 结束直播
  endLiveChannel: params =>
    http.post('/p/wedding/index.php/admin/APILiveChannel/endLiveChannel', {
      body: params
    }),
  // 直播线路编辑
  editLiveLine: params =>
    http.post('/p/wedding/index.php/admin/APILiveChannel/editLiveLine', {
      body: params
    })
}
